import { call, put, delay } from 'redux-saga/effects';
import axios from 'axios';
import {
  fetchDocumentFileSuccessAction,
  fetchDocumentFileErrorAction,
} from 'actions/documentMeta';

export function* fetchDocumentFile(url: string) {
  try {
    let responseStatus = 404;

    while (responseStatus !== 200) {
      try {
        const response = yield call(axios.head, url);
        responseStatus = response.status;
      } catch (e) {
        yield delay(1000);
      }
    }

    yield put(fetchDocumentFileSuccessAction());
  } catch (e) {
    yield put(
      fetchDocumentFileErrorAction(
        e.response?.data?.message,
        e.response?.status
      )
    );
  }
}
